import { db } from "./init";
import { collection, doc, CollectionReference, DocumentReference } from "firebase/firestore";
import type { DbShop } from "@/shared/typings/types/shop";

export const shopsCollection = () => {
  return collection(db, "shops") as CollectionReference<DbShop>;
};

export const shopDoc = (shop: string) => {
  return doc(db, "shops", shop) as DocumentReference<DbShop>;
};
